<template>
  <div
    class="flex flex-col flex-wrap items-start justify-between gap-y-3 md:flex-row md:items-center"
    :class="{ 'my-6 md:my-4': contentInner }"
  >
    <div class="shrink-0">
      <div class="flex items-center gap-x-1">
        <h3
          class="text-2xl font-medium leading-8 tracking-normal md:leading-3"
          :class="{ 'md:text-3xl': !contentInner, 'text-gray-700': !titleColor, 'zuno-primary-2': titleColor }"
        >
          {{ title }}
        </h3>
        <span
          v-if="title && !hideIconModal"
          class="mb-0 ml-1 text-gray-600"
        >
          <PurchaseInfoGuideModal v-if="title === 'Purchased Electricity'" />
          <HeatandSteamGuideModal v-if="title === 'Heat and Steam'" />
        </span>
        <small v-if="smallTitleText">{{ smallTitleText }}</small>
      </div>
      <p class="mt-1 text-base leading-6 tracking-normal text-gray-400 md:mt-3">
        {{ subtitle }}
      </p>
    </div>
    <div class="flex flex-wrap items-center gap-3">
      <slot name="rightSideButtons" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainHeader',

  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    contentInner: {
      type: Boolean,
      default: true,
    },
    guidanceIcon: {
      type: String,
      default: '',
    },
    smallTitleText: {
      type: String,
      default: '',
    },
    titleColor: {
      type: Boolean,
      default: false,
    },
    hideIconModal: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
